import { handleApiResponse } from "../utils/apiUtils";
import secureApi from "./secureApi";

/** Issue #70: 本人のメンバーシップ情報（マイページの更新日表示用） */
export const getMembership = () =>
  handleApiResponse(() => secureApi.get("/user/membership"));
